'use client';

import { c as _c } from "react/compiler-runtime";
import { UPSKILLING_TARGET_BORDER_DASH } from '@/domains/pages/ai-proficiency/components/upskilling-chart-styles';
import { cn } from '@/utils/shad';
const LEGEND_DASH_LINE_WIDTH = 22;
function LegendDashLine(t0) {
  const $ = _c(6);
  const {
    dasharray,
    width: t1
  } = t0;
  const width = t1 === undefined ? LEGEND_DASH_LINE_WIDTH : t1;
  let t2;
  if ($[0] !== dasharray || $[1] !== width) {
    t2 = <line x1={0} y1={2} x2={width} y2={2} stroke="currentColor" strokeWidth={1.5} strokeDasharray={dasharray} />;
    $[0] = dasharray;
    $[1] = width;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== t2 || $[4] !== width) {
    t3 = <svg width={width} height={4} className="text-muted-foreground" aria-hidden={true}>{t2}</svg>;
    $[3] = t2;
    $[4] = width;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  return t3;
}
export function UpskillingChartLegend(t0) {
  const $ = _c(7);
  const {
    className
  } = t0;
  let t1;
  if ($[0] !== className) {
    t1 = cn("flex flex-wrap items-center gap-4 text-xs text-muted-foreground", className);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <span className="inline-flex items-center gap-1.5"><span className="size-2.5 rounded-sm bg-muted-foreground" aria-hidden={true} />Group (filled)</span>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <span className="inline-flex items-center gap-1.5"><span className="h-0 border-t border-dashed border-muted-foreground" style={{
        width: LEGEND_DASH_LINE_WIDTH
      }} aria-hidden={true} />Org avg</span>;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <span className="inline-flex items-center gap-1.5"><LegendDashLine dasharray={UPSKILLING_TARGET_BORDER_DASH.join(" ")} />Target for the level</span>;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== t1) {
    t5 = <div className={t1} data-testid="upskilling-chart-legend">{t2}{t3}{t4}</div>;
    $[5] = t1;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  return t5;
}